module.exports = __webpack_public_path__ + "img/background.bf4b38f4.png";